import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Customers from '../sales/Customers';
import Suppliers from '../purchases/Suppliers';
import UsersPage from '../../pages/people/UsersPage';

const People = () => {
  return (
    <Routes>
      <Route path="customers" element={<Customers />} />
      <Route path="suppliers" element={<Suppliers />} />
      <Route path="users" element={<UsersPage />} />
    </Routes>
  );
};

export default People; 